import { render, staticRenderFns } from "./ShipRow.vue?vue&type=template&id=696e936c&scoped=true&"
import script from "./ShipRow.vue?vue&type=script&lang=js&"
export * from "./ShipRow.vue?vue&type=script&lang=js&"
import style0 from "./ShipRow.vue?vue&type=style&index=0&id=696e936c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "696e936c",
  null
  
)

export default component.exports